import type { EvaluatedStatus } from '@/features/execute-calculation-set/overmind/calculation';

import type { AttentionStatusType } from './evaluation/AttentionStatus';

export class AttentionStatusTranslator
  implements ForAttentionStatusTranslation
{
  private translationMap: Map<AttentionStatusType, EvaluatedStatus>;

  constructor(translations: [AttentionStatusType, EvaluatedStatus][]) {
    this.translationMap = new Map(translations);
  }

  public static default(): AttentionStatusTranslator {
    return new AttentionStatusTranslator([
      ['ATTENTION_REQUIRED', 'Bad'],
      ['ATTENTION_SUGGESTED', 'Warning'],
      ['NO_ATTENTION_REQUIRED', 'Good'],
      ['NOT_EVALUATED', 'NotEvaluated']
    ]);
  }

  translate(input: AttentionStatusType): EvaluatedStatus {
    return this.translationMap.get(input) || 'NotEvaluated';
  }
}

export type ForAttentionStatusTranslation = {
  translate: (input: AttentionStatusType) => EvaluatedStatus;
};
